<template>
  <div class="enterpriseBigData index">
    企业实时运行平台
    
  </div>
</template>

<script>
export default {
  name: "enterpriseBigData",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>


</style>
